export default {"src":"/trader-new/_next/static/media/homeFooterActive.72b1a44b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};